import { ApiError } from '@/lib/api-client';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export function useApiQuery<TData = unknown, TError = ApiError>(
  queryKey: string[],
  queryFn: () => Promise<TData>,
  options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>,
) {
  return useQuery<TData, TError>({
    queryKey,
    queryFn,
    ...options,
  });
}

// Example usage:
// const { data, isLoading, error } = useApiQuery(
//   ['trending-tokens'],
//   () => api.getTrendingTokens(),
//   { staleTime: 30000 }
// );
